<div class='homePageContainer'>
    <app-home-feed></app-home-feed>
    <button  class="createModel" (click)="createModel()">Create Model</button>
</div>
